import styled from 'styled-components'
import {
  BREAK_POINT_LG,
} from '@CSSVars/variables'

export const _ListContentContainer = styled.div`
  padding: 0;
  width: 100%;
  border-radius: 10px;
  ${({ multiListings }) => (multiListings ? `
    width: calc(100% - 32px);
    margin: 16px 16px 0;
    
    @media screen and (max-width: ${BREAK_POINT_LG}) {
      border-radius: 10px;
    }
  ` : '')}

`
